import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    button: {
        minWidth: 150,
        margin: 2
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
        display: 'flex'
    },
}));

export { useStyles };